module.exports = __webpack_public_path__ + "img/onto.d4391e47.png";